import { theme } from 'antd';
import { CalendarIcon, DeletedFilled } from 'assets/images/svg';
import { useManagePermittedRoles } from 'library/hooks';
import React, { useState } from 'react';
import { CreateBookingModal, DeleteDeviceModal } from 'zComponents/molecules';
import { Button, Divider, Dropdown, Flex } from 'zui/Antd';

const ManageLockerDropdown = ({ children, deviceID, isTransparent = false }) => {
	// ✅ Hooks
	const {
		token: { colorBgContainer, boxShadow, borderRadiusLG, paddingSM, colorPrimaryText, fontWeightStrong, padding }
	} = theme.useToken();

	// ✅ Local States
	const [openDropdown, setOpenDropdown] = useState(false);
	const [openDelete, setOpenDelete] = useState(false);

	// Permission check for adding booking
	const canAddBooking = useManagePermittedRoles('addBooking');

	const items = [
		{
			key: 'Create Booking',
			label: (
				<CreateBookingModal deviceID={deviceID}>
					<Button
						type='text'
						icon={<CalendarIcon color='currentColor' />}
						block
						disabled={!canAddBooking}
						style={{
							justifyContent: 'flex-start',
							fontWeight: fontWeightStrong
						}}
					>
						Create Booking
					</Button>
				</CreateBookingModal>
			)
		},

		{
			key: '',
			label: <Divider style={{ margin: 0 }} />
		},

		{
			key: 'Delete Locker',
			label: (
				<DeleteDeviceModal open={openDelete} setOpen={setOpenDelete} deviceID={deviceID} isLocker>
					<Button
						type='text'
						danger
						icon={<DeletedFilled width={16} height={16} color='currentColor' />}
						block
						style={{
							justifyContent: 'flex-start',
							fontWeight: fontWeightStrong
						}}
						disabled={true}
					>
						Delete Locker
					</Button>
				</DeleteDeviceModal>
			)
		}
	];

	return (
		<>
			<Dropdown
				trigger={['click']}
				placement='bottomLeft'
				open={openDropdown}
				onOpenChange={(visible) => setOpenDropdown(visible)}
				dropdownRender={() => (
					<Flex
						style={{
							backgroundColor: colorBgContainer,
							borderRadius: borderRadiusLG,
							width: 240,
							boxShadow: boxShadow,
							padding: `${padding}px ${paddingSM}px`,
							position: 'relative'
						}}
						vertical
						gap={padding}
					>
						{items.map((item) => item.label)}
					</Flex>
				)}
			>
				{children ? (
					children
				) : (
					<Button
						type={isTransparent ? 'text' : 'primary'}
						style={{ color: isTransparent && colorPrimaryText }}
					>
						{isTransparent ? 'View' : 'Manage'} Locker
					</Button>
				)}
			</Dropdown>
		</>
	);
};

export default ManageLockerDropdown;
